// extracted by mini-css-extract-plugin
module.exports = {"tradeAppliedToast":"TradeAppliedToastContent_tradeAppliedToast__YRr8s"};